import React from 'react'

import CircularProgress from '@mui/material/CircularProgress'

import { LabelValuePair, UserRole } from '@/types'
import getAllowedRolesByUserRole from '@/utils/rolePermissions'
import Select, {
	type SelectChangeEvent,
} from '../formControls/Select'
import useRoleList from '../../hooks/useRoleList'
import FormControl from '../formControls/FormControl'

type ShareLoanAssignedRoleCellProps = {
	row: UserRole
	disabled?: boolean
	showRolesBasedOnUserRole?: boolean
	onChangeRoleItem?: (
		e: SelectChangeEvent<unknown>,
		userId: string
	) => void
}

const ShareLoanAssignedRoleCell = ({
	row,
	disabled,
	showRolesBasedOnUserRole = true,
	onChangeRoleItem,
}: ShareLoanAssignedRoleCellProps) => {
	const allowedRoles =
		showRolesBasedOnUserRole && row.user?.role
			? getAllowedRolesByUserRole(row.user.role)
			: undefined

	const { getRoleList } = useRoleList()

	const roleOptionList = getRoleList({
		includeRoles: allowedRoles,
	})

	return (
		<FormControl
			size="small"
			sx={{
				display: 'flex',
				flexDirection: 'row',
				gap: 2,
				alignItems: 'center',
				paddingTop: '20px',
			}}
		>
			<Select<LabelValuePair>
				size="small"
				menuItems={roleOptionList}
				disabled={disabled}
				selectProps={{
					value: row.assignedRole,
					onChange: (e: SelectChangeEvent<unknown>) =>
						onChangeRoleItem?.(e, row.user.id),
				}}
				sx={{ width: 220 }}
			/>

			{row.loadingEdit && (
				<CircularProgress size={20} sx={{ mb: 2 }} />
			)}
		</FormControl>
	)
}

export default ShareLoanAssignedRoleCell
